class HFCustomFG {
  constructor() {
    // console.log("HFCustomFG has been loaded.");
  }

  run() {
    // console.log("HFCustomFG is running.");
    this._journeyPackGift();
    
    this.cartUpdateEventInterceptor(() => {
      // console.log("HFCustomFG [event: cart-update]");
      this._journeyPackGift();
    });

    this.cartCheckoutButtonInterceptor(() => {
      // console.log("HFCustomFG [event: checkout-button-click]");
      this._journeyPackGift();
    })

    // Run _journeyPackGift every 10 seconds to ensure cart is updated as fallback
    setInterval(() => {
      this._journeyPackGift();
    }, 10000);
  }

  cartUpdateEventInterceptor(callback) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      try {
        callback();
      } catch (e) { }
    })
  }
  
  cartCheckoutButtonInterceptor(callback) {
    try {
      $('.cart__checkout-button').on("click", (event) => {
        callback();
      });
    } catch (e) {}
  }

  // 
  
  _journeyPackGift() {
    const jpGifts = this.context.JourneyPack;
    // console.log("HFCustomFG [run-method: joruneyPackGift]", this.context.JourneyPack);

    // Fetch /cart.js (json)
    const _cart = fetch('/cart.js?HFCustomFG_Fetch=true')
      .then((res) => {
        if (!res.ok) {
          throw new Error("HFCustomFG [exception: Unable to retrieve data from cart.]");
        }

        return res.json();
      })
      .then((cart) => {
      // console.log("HFCustomFG [run-method: joruneyPackGift] | Cart Data (Items)", cart.items);

      let bundleGiftObj = [];
      let giftObj = {};
      let giftAggregateObj = [];

      const cartItems = cart.items;
      cartItems.forEach((item, idx) => {
        const itemIdMatchGift = this.context.JourneyPack.bundles.find(p => p.freegift_product.variant_id === item.id);
        // Match JP variant
        if (this.context.JourneyPack.variants.find(p => p === item.id)) {
          // console.log("HFCustomFG [run-method: joruneyPackGift] | Journey Pack Variant ID Matched");

          // Read JP Childlines
          const propertyChildlines = JSON.parse(item.properties['_childLines']);
          // console.log("HFCustomFG [run-method: joruneyPackGift] | Cart Data (Item Property Child Lines)", propertyChildlines);

          for (const key in propertyChildlines) {
            if (propertyChildlines.hasOwnProperty(key)) {
              const value = propertyChildlines[key] * item.quantity;

              // Get the corresponding Variant ID of Product
              const giftMatch = this.context.JourneyPack.bundles.find(p => p.variants.includes(parseInt(key)));
              const giftMatchVariantId = giftMatch.freegift_product.variant_id;
              bundleGiftObj.push({
                match_variant_id: key,
                gift_variant_id: giftMatch.freegift_product.variant_id,
                quantity: value
              })

              // Push to giftAggregateObj
              giftAggregateObj.push({
                gift_variant_id: giftMatch.freegift_product.variant_id,
                quantity: value
              });

              if (giftObj.hasOwnProperty(giftMatchVariantId)) {
                // Add giftObj[giftMatchVariantId] + value
                giftObj[giftMatchVariantId] = giftObj[giftMatchVariantId] + value;
              } else {
                // Set giftObj[giftMatchVariantId] = value
                giftObj[giftMatchVariantId] = value;
              }
            }
          }
        } else if (itemIdMatchGift) {
          // Remove the gift
          giftObj[item.id] = 0;
        }
      });

      // Order by gift_variant_id to ensure consistent order, set as new variable
      const orderedGiftAggregateObj = giftAggregateObj
      .sort((a, b) => a.gift_variant_id - b.gift_variant_id)
      .reduce((acc, curr) => {
        const existing = acc.find(
          g => g.gift_variant_id === curr.gift_variant_id
        );

        if (existing) {
          existing.quantity += curr.quantity;
        } else {
          acc.push({
            gift_variant_id: curr.gift_variant_id,
            quantity: curr.quantity
          });
        }

        return acc;
      }, []);
      // console.log("HFCustomFG [run-method: joruneyPackGift] | Ordered Gifts Aggregate", orderedGiftAggregateObj);

      let giftObjFinal = {};
      // Find gifts in carts that doesn't exist in orderedGiftAggregateObj but exist in cart
      cartItems.forEach((item, idx) => {
        
        const itemIdMatchGift = this.context.JourneyPack.bundles.find(p => p.freegift_product.variant_id === item.variant_id.toString());

        // console.log("HFCustomFG [run-method: joruneyPackGift] | Checking Cart Item for Removal", item.id, item.title, itemIdMatchGift);

        if (itemIdMatchGift) {
          const giftInAggregate = orderedGiftAggregateObj.find(g => g.gift_variant_id === item.id);
          
          if (!giftInAggregate) {
            // Remove the gift
            giftObjFinal[item.id] = 0;
          }
        }
      });
      // load orderedGiftAggregateObj by gift_variant_id, if there are multiple of the same gift_variant_id, sum them up

      orderedGiftAggregateObj.forEach((gift) => {
        giftObjFinal[gift.gift_variant_id] = gift.quantity;
      });

      // console.log("HFCustomFG [run-method: joruneyPackGift] | Bundles", bundleGiftObj);
      // console.log("HFCustomFG [run-method: joruneyPackGift] | Gifts Final", giftObjFinal);

      // Call fetch
      fetch('/cart/update.js?HFCustomFG_Fetch=true', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates: giftObjFinal }),
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to remove item from cart');
        }

        refreshCartFunc();

        if (window.location.pathname === '/cart') {
          // Reload the page if the current location is "/cart"
          refreshCartFunc("cart-page");
        }
      })
      .then((updatedCart) => {
        // // console.log('Item removed successfully:', updatedCart);
        // Optionally, refresh the page or update the cart UI
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    })
    
  }

  
}

const updateGiftWithoutParentProrduct = () => {
    const _el = document.querySelectorAll(".cart-item");
    let _updates = {};

    let _flavorNames = {};
    let getFlavorsFromCartProperties = document.querySelectorAll(".product-option[data-property-type='flavor']:not(.main-cart-product-option)");
    if (window.location.pathname === '/cart') {
      // Reload the page if the current location is "/cart"
      getFlavorsFromCartProperties = document.querySelectorAll(".main-cart-product-option[data-property-type='flavor']");
    }
    getFlavorsFromCartProperties.forEach((flavor, index) => {
      const _quantity = parseInt(flavor.getAttribute("data-property-quantity"));
      const _flavor = flavor.getAttribute("data-property-name");

      let _finalQuantity = _quantity;
      if (_flavorNames[_flavor] !== undefined) {
        _finalQuantity = _flavorNames[_flavor] + _quantity;
      }

      _flavorNames[_flavor] = _finalQuantity;

      
    });
    // console.log("FLAVOR", _flavorNames);
    

    _el.forEach((item, index) => {
      let _itemProductName = item.getAttribute("data-cart-product-name");
      const _itemLineNo = parseInt(item.getAttribute("data-cart-line-no"));
      const _itemVariantId = parseInt(item.getAttribute("data-cart-variant-id"));
      const _giftParentId = item.getAttribute("data-cart-boxing-day-gift-parent-product");
      const _isBoxingDayGift = JSON.parse(item.getAttribute("data-cart-is-boxing-day-gift"));

      if (_isBoxingDayGift) {
        // Check if _giftParentId exist in _el as 'data-cart-product-id'
        const _parentAddedToCart = Array.from(_el).find((el) => 
          el.getAttribute("data-cart-product-id") === _giftParentId
        );

        if (!_parentAddedToCart) {
          _updates[_itemVariantId] = 0;
        }

        /**
        * Update Quantity when 'cart-update' event has been triggered.
        */
        // Remove "(Free Gift)" from '_itemProductName'
        _itemProductName = _itemProductName.replace("(Free Gift)", "").trim();
        if (_flavorNames[_itemProductName] !== undefined) {
          _updates[_itemVariantId] = _flavorNames[_itemProductName];
        }

        // console.log("UPDATE GIFT", _itemProductName, _flavorNames);
        // // console.log("Item", item, "giftParentId", _giftParentId, "isBoxingDayGift", _isBoxingDayGift, "parentAddedToCart", _parentAddedToCart);
      }
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates: _updates }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to remove item from cart');
        }

        refreshCartFunc();

        if (window.location.pathname === '/cart') {
          // Reload the page if the current location is "/cart"
          window.location.reload();
        }

        
        // return response.json();
      })
      .then((updatedCart) => {
        // // console.log('Item removed successfully:', updatedCart);
        // Optionally, refresh the page or update the cart UI
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

document.addEventListener('DOMContentLoaded', (event, cart) => {
  // Fetch interceptor
  const cartChangeInterceptor = (() => {
    let isInterceptorApplied = false;
  
    return () => {
      if (isInterceptorApplied) {
        console.warn("Interceptor already applied.");
        return; // Exit if already applied
      }
  
      isInterceptorApplied = true;
  
      const originalFetch = window.fetch;
  
      // Override the global fetch function
      window.fetch = async function (input, init) {
        // Check if the request is to '/cart/change' and is a POST request
        const isTargetRequest = 
          typeof input === 'string' && 
          (input.includes('/cart/change') || input.includes('/cart/update') || input.includes('/cart') || input.includes('/cart/update.js')) &&
          init?.method?.toUpperCase() === 'POST';
  
        if (isTargetRequest) {    
          const cartDrawerCheckoutButton = document.getElementById("CartDrawer-Checkout");
          const cartPageCheckoutButton = document.getElementById("checkout");
          
          if (cartDrawerCheckoutButton) {
            cartDrawerCheckoutButton.setAttribute('disabled', 'true');
          }
  
          if (cartPageCheckoutButton) {
            cartPageCheckoutButton.setAttribute('disabled', 'true');
          }
          
          try {
            // Proceed with the original fetch call
            const response = await originalFetch(input, init);
  
            // Wait for the response to resolve and process the data
            const data = await response.clone().json(); // Clone response to safely consume the body
            
            if (cartDrawerCheckoutButton) {
              cartDrawerCheckoutButton.removeAttribute('disabled');
            }
            if (cartPageCheckoutButton) {
              cartPageCheckoutButton.removeAttribute('disabled');
            }
  
            return response; // Return the original response to ensure normal functionality
          } catch (error) {
            console.error("Fetch error:", error);
            document.body.classList.remove('loading');
          }
        }
  
        // If not the target request, call the original fetch
        return originalFetch(input, init);
      };
    };
  })();
  cartChangeInterceptor();
});



